import { createStandardAction } from 'typesafe-actions';

import { Dictionary } from '@travel/translation';

export const setDictionary = createStandardAction('SET_DICTIONARY')<Dictionary>();
